import { render, staticRenderFns } from "./Item2.vue?vue&type=template&id=33473db1&scoped=true&"
import script from "./Item2.vue?vue&type=script&lang=js&"
export * from "./Item2.vue?vue&type=script&lang=js&"
import style0 from "./Item2.vue?vue&type=style&index=0&id=33473db1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33473db1",
  null
  
)

export default component.exports